/**
 * Decides whether a wheel gesture over node content should scroll that content
 * instead of panning the canvas. Content only wins while it can still scroll in
 * the gesture's direction; pinch (ctrl/meta + wheel) always zooms the canvas.
 */
export function nodeContentConsumesWheel(event: WheelEvent, boundary: Element): boolean {
  if (event.ctrlKey || event.metaKey) return false
  const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY)
  const delta = horizontal ? event.deltaX : event.deltaY
  if (!delta) return false

  let element = event.target instanceof Element ? event.target : null
  while (element && element !== boundary) {
    if (element instanceof HTMLElement) {
      const style = getComputedStyle(element)
      const overflow = horizontal ? style.overflowX : style.overflowY
      if (overflow === 'auto' || overflow === 'scroll') {
        const position = horizontal ? element.scrollLeft : element.scrollTop
        const max = horizontal
          ? element.scrollWidth - element.clientWidth
          : element.scrollHeight - element.clientHeight
        if (max > 0 && (delta < 0 ? position > 0 : position < max - 1)) return true
      }
    }
    element = element.parentElement
  }
  return false
}

/** Capture-phase listener for the canvas wrapper: lets scrollable node content keep its own scroll. */
export function isolateNodeContentWheel(event: WheelEvent): void {
  const node = event.target instanceof Element ? event.target.closest('.react-flow__node') : null
  if (node && nodeContentConsumesWheel(event, node)) event.stopPropagation()
}
